import { getListDataFunctionFactory } from '../../../modules/getListDataFunctionFactory'
import type { ILeadSourceEvent } from '~/types/leadSource/models'
import type { TEntityId } from '~/types/models'

const leadSourceEventListData = undefined as unknown as ILeadSourceEvent[]

export const getLeadSourceEventListData = getListDataFunctionFactory<
  ILeadSourceEvent[]
>({
  listData: leadSourceEventListData,
  storageKey: 'leadsourceevents',
  getStartingListData: getStartingLeadSourceEventListData,
})

export async function getLeadSourceEventDataById(
  id: TEntityId
): Promise<ILeadSourceEvent> {
  const list: ILeadSourceEvent[] = await getLeadSourceEventListData()
  if (!list) {
    throw new Error(`getLeadSourceEventListData returned undefined/null`)
  }
  const lsc = list.find((leadSourceEvent) => leadSourceEvent.id === id)
  if (!lsc) {
    throw new Error(`Can't find leadSourceEvent '${id}'`)
  }
  return lsc
}

export async function getLeadSourceEventDataByDescr(
  descr: string
): Promise<ILeadSourceEvent> {
  const list: ILeadSourceEvent[] = await getLeadSourceEventListData()
  if (!list) {
    throw new Error(`getLeadSourceEventListData returned undefined/null`)
  }
  const lsc = list.find((leadSourceEvent) => leadSourceEvent.descr === descr)
  if (!lsc) {
    throw new Error(`Can't find leadSourceEvent '${descr}'`)
  }
  return lsc
}

export async function getStartingLeadSourceEventListData(): Promise<
  ILeadSourceEvent[]
> {
  return [
    {
      id: 'XXLCMSS0001',
      hrid: 'LCMSS0001',
      descr: '2023-04 | Call & Contact Center Expo',
      status: { id: 1, label: 'Active' },
      version: '1',
      canBeDeleted: true,
    },
    {
      id: 'XXLCMSS0002',
      hrid: 'LCMSS0002',
      descr: '2023-06 | CX North America',
      status: { id: 1, label: 'Active' },
      version: '1',
      canBeDeleted: true,
    },
    {
      id: 'XXLCMSS0003',
      hrid: 'LCMSS0003',
      descr: '2023-06  | TECHSPO (Charlotte)',
      status: { id: 1, label: 'Active' },
      version: '1',
      canBeDeleted: true,
    },
  ]
}
